import React from 'react';
import * as styles from './shPaymentModalGoBack.module.scss';

import ChevronLeft from "../../../public/icons/chevronLeft.svg";

const ShPaymentModalGoBack = ( { action = () => { } } ) => {

    return <div className={"c-pointer d-flex align-items-center opacity-50 small-text"}
                onClick={action} >

        <ChevronLeft className={styles.svg} />
        Schritt zurück

    </div>

};

export default ShPaymentModalGoBack;
